import QueryWhereRules from './query-where-rules';
import { types } from '~/components/query/query-editor/query-editor.controller';
import QueryWhereNode from './query-where-node';
import QueryWhereChild from './query-where-child';
import QueryHaving from './query-having';

/** @type {Record<string,string>} */
export const defaultFieldByType = {
	datetime: 'repre',
	file: 'repre',
	number: 'repre',
	string: 'kid',
};

export default class QueryWhereRule {
	/** @type {?QueryWhereNode} */
	#node = null;

	/** @type {?(import('./query-where-child').default | QueryWhereRules)} */
	#parent = null;

	/**
	 * @param {any} rule
	 * @param {?QueryWhereNode} node
	 */
	constructor(rule = null, node = null) {
		this.#node = node;

		/** @type {string | undefined} */
		this.attribut = rule?.attribut;

		/** @type {'AND' | 'OR' | undefined } */
		this.condition = rule?.condition;

		let defaultField = 'kid';
		if (node instanceof QueryWhereNode && node.type in types) {
			defaultField = defaultFieldByType[types[node.type]];
		}

		/** @type {'attribut'|'datecreation'|'dated'|'datef'|'file'|'isa'|'kid'|'ref_propri'|'repre'} */
		this.field = rule?.field === undefined ? defaultField : rule.field;

		/** @type {import('./query-having').default | undefined} */
		this.having = rule?.having ? new QueryHaving(rule.having) : undefined;

		/** @type {import('@knitiv/api-client-javascript').KNodeOptional | undefined} */
		this.lang_kid = rule?.lang_kid;

		/** @type {string | undefined} */
		this.operator = rule?.operator;

		/** @type {?QueryWhereRules} */
		this.rules = rule?.rules ? new QueryWhereRules(rule.rules, node) : null;

		/** @type {any} */
		this.value = rule?.value;

		/** @type {any} */
		this.variable = rule?.variable;
	}

	isNodeRule() {
		return true;
	}

	/**
	 * @returns {?QueryWhereNode} node
	 */
	getNode() {
		return this.#node;
	}

	/**
	 * @param {?QueryWhereNode} node
	 */
	setNode(node) {
		this.#node = node;
	}

	/**
	 *
	 * @param {import('./query-where-child').default | QueryWhereRules} parent
	 */
	setParent(parent) {
		this.#parent = parent;
	}

	isDateRange() {
		return this.#node?.type === 'K_NODE;DATE'
			&& (
				this.value?.unit !== undefined
				|| (Array.isArray(this.value) && this.value.length > 0 && this.value[0]?.unit !== undefined)
			);
	}

	get parent() {
		return this.#parent;
	}

	/**
	 * @returns {*[]}
	 */
	get path() {
		/** @type {any[]} */
		const path = []

		// TODO: make it recursive
		if (this.#parent instanceof QueryWhereChild) {
			path.push(this.#parent.node);
		}
		path.push(this.#node);
		return path;
	}
}
